var $ = require('jquery');

var $header = $('.fs-l-header');

// Nav Toggle Button
$('.fs-l-header__drawerOpener').click(function(){
    $header.toggleClass('is-open');
});